module.exports = __webpack_public_path__ + "buildingstore_cases.jpg?833e46abb5bc1809bb7c54f7536aa490";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/buildingstore_cases.jpg
// module id = 85
// module chunks = 0